import Link from 'next/link'
import styled from 'styled-components'
import { TOP_BAR_HEIGHT_DESKTOP, TOP_BAR_HEIGHT_MOBILE } from '@/constant/ui'

export const Wrapper = styled.nav`
  background: white;
  padding: 0 25px;
  width: 100%;
  box-sizing: border-box;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    padding: 16px;
    height: 68px;
  }
`
export const TopbarContainer = styled.div`
  position: sticky;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 4;
`
export const BodySpacer = styled.div<{ height: number }>`
  height: ${({ height }) => height}px;

  + div .sticky-top {
    top: ${({ height }) => height}px;
  }
`
export const MenuContainer = styled.div`
  display: flex;
  align-items: center;

  & img {
    margin-right: 40px;
  }

  @media (max-width: 600px) {
    & img {
      margin-right: 0;
    }
  }
`
export const BurgerLine = styled.div`
  background: var(--brand-secondary);
  width: 20px;
  height: 2px;
  border-radius: 5px;
  position: absolute;
  left: 0;
  transition: 0.3s var(--cubicBezier);

  &:nth-child(1) {
    top: 0;
  }
  &:nth-child(2) {
    top: 50%;
    transform: translateY(-50%);
  }
  &:nth-child(3) {
    top: auto;
    bottom: 0;
  }
`
export const Burger = styled.div<{ isToggled: boolean }>`
  margin-right: 20px;
  width: 20px;
  height: 14px;
  position: relative;
  cursor: pointer;
  transition: 0.3s var(--cubicBezier);

  ${({ isToggled }) =>
    isToggled &&
    `
    .line-1 {
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%) rotate(45deg);
    }
    .line-2 {
      opacity: 0;
    }
    .line-3 {
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%) rotate(-45deg);
    }
  `}

  &:hover {
    transform: scale(1.1);
  }
`
export const MenuItemWrapper = styled.div<{ color?: string }>`
  display: flex;
  flex-direction: row;
  font-size: 16px;
  margin-right: 30px;
  cursor: pointer;
  text-transform: capitalize;
  color: ${({ color }) => color ?? 'var(--brand-secondary)'};
  font-weight: var(--font-medium);

  a {
    text-decoration: none;
    color: ${({ color }) => color ?? 'var(--brand-secondary)'};
  }

  .icon-left {
    margin-right: 6px;
    position: relative;
    top: -1px;
  }

  .icon-right {
    margin-left: 8px;
  }

  @media (max-width: 1024px) {
    display: none;
  }
`
export const OffCanvasMenuItemWrapper = styled.div<{ color?: string }>`
  display: flex;
  flex-direction: row;
  font-size: 16px;
  margin-right: 30px;
  justify-content: center;
  cursor: pointer;
  text-transform: capitalize;
  color: ${({ color }) => color ?? 'var(--brand-secondary)'};
  align-items: center;
`
export const MenuItemText = styled.span`
  font-weight: var(--font-medium);
  @media (max-width: 1024px) {
    display: none;
  }
`
export const MenuItemLink = styled(Link)`
  @media (max-width: 1024px) {
    display: none;
  }
`
export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`
export const ClearSearch = styled.svg`
  width: 20px;
  height: 20px;
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
  right: 15px;
  cursor: pointer;

  @media (max-width: 768px) {
    right: 35px;
  }
`
export const SearchButton = styled.button`
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background: var(--brand-secondary);
  color: white;
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
  right: 6px;
  font-size: 11px;

  @media (max-width: 768px) {
    display: none;
  }
`
export const SearchTrigger = styled.div`
  display: none;
  cursor: pointer;
  display: block;
`
export const Icons = styled.div`
  margin-left: 20px;
  align-items: center;
  display: flex;

  svg {
    width: 24px;
    height: 24px;
  }

  @media (max-width: 768px) {
    margin-left: 0;

    svg {
      width: 24px;
      height: 24px;
    }
  }
`
export const UserInitials = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--brand-primary);
  font-size: 12px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  cursor: pointer;
`

export const SantaHat = styled.div`
  position: absolute;
  width: 23px;
  height: 23px;
  z-index: 2;
  left: -12px;
  top: 13px;
  transform: rotate(-38deg);
`
export const DesktopLogo = styled.div<{ showOnMobile?: boolean }>`
  display: block;
  position: relative;

  @media (max-width: 374px) {
    img {
      width: 100px !important;
    }
  }

  ${({ showOnMobile }) =>
    !showOnMobile &&
    `
    @media (max-width: 1200px) {
      display: none;
    }
  `}
`

export const MobileLogo = styled.div`
  display: none;

  @media (max-width: 1200px) {
    display: block;
  }
`

export const CartIcon = styled.div`
  position: relative;
`

export const Total = styled.div`
  position: absolute;
  top: -1px;
  right: -4px;
  width: 14px;
  height: 14px;
  background: var(--sale);
  text-align: center;
  color: white;
  font-size: 11px;
  font-weight: var(--font-bold);
  line-height: 15px;
  border-radius: 50%;

  @media (max-width: 768px) {
    top: -4px;
    right: -7px;
  }
`

export const IconWrapper = styled.span`
  width: 16px;
  height: 16px;
  margin-right: 6px;
  position: relative;
  top: -1px;
  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`
